module.exports = __webpack_public_path__ + "img/拒绝转借.03be72a7.png";